import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import { SecondaryDangerButton } from "../../../../../components/customComponent";
import { useDispatch } from "react-redux";
import { editAllSMPDisruption } from "../../../../store/actions/bplrt/smpAction";
import { useTranslation } from "react-i18next";
import parser from "html-react-parser";

const SaveDisruption = ({
  platformData,
  trackData,
  handleResetState,
  setIsChanged,
  isChanged,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("bplrtSmp");

  const [openSaveDialog, setOpenSaveDialog] = useState(false);

  const saveChanges = () => {
    const payload = {};
    const platformsArr = platformData.map(({ id, isDisrupted }) => ({
      id,
      isDisrupted,
    }));
    const tracksArr = trackData.map(({ id, isDisrupted }) => ({
      id,
      isDisrupted,
    }));
    payload["platforms"] = platformsArr;
    payload["tracks"] = tracksArr;

    dispatch(editAllSMPDisruption(payload));
    setOpenSaveDialog(false);
    handleResetState();
    setIsChanged(false);
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={() => {
          setOpenSaveDialog(true);
        }}
        sx={{ boxShadow: 3, mr: "8px" }}
        disabled={!isChanged}
      >
        {t("saveMapBtn")}
      </Button>
      <Dialog
        maxWidth="sm"
        open={openSaveDialog}
        onClose={() => {
          setOpenSaveDialog(false);
        }}
      >
        <DialogContent>
          <DialogContentText
            sx={{
              textAlign: "center",
              mb: 2,
            }}
          >
            {parser(t("saveMapConfirmationHint"))}
          </DialogContentText>

          <Box>
            <Alert severity="warning" variant="outlined">
              <strong>{t("saveMapConfirmationAlert")}</strong>
            </Alert>
          </Box>
        </DialogContent>

        <DialogActions>
          <SecondaryDangerButton
            fullWidth
            startIcon={<ClearIcon />}
            onClick={() => {
              setOpenSaveDialog(false);
            }}
          >
            {t("cancelBtn")}
          </SecondaryDangerButton>

          <Button
            fullWidth
            variant="contained"
            startIcon={<DoneIcon />}
            onClick={() => saveChanges()}
          >
            {t("saveMapSubmitBtn")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SaveDisruption;
